WYATT.registerComponent(
  "product-recommendations",
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.endpoint = this.dataset.productRecommendations;
      const options = { rootMargin: "0px 0px 200px 0px" };
      const observer = new IntersectionObserver(
        this.handleIntersection,
        options
      );
      observer.observe(this);
    }

    handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) {
        return;
      }

      observer.unobserve(this);

      fetch(this.endpoint)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(
            "[data-product-recommendations]"
          );

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            WYATT.refreshYotpo();
          }
        });
    };
  }
);
